import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { parseJwt } from "../../components/utilities/utils";
import { BASE_URLS, PLATFORM_TYPE } from "../../constants/constants";

export const userServiceApi = createApi({
  reducerPath: "userServiceApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URLS.USERMANAGEMENT_BASE_URL,
    prepareHeaders: (headers) => {
      headers.set("PLATFORM-TYPE", PLATFORM_TYPE);
      if(localStorage.access_token && localStorage.access_token !=""){
        headers.set("authorization", `Bearer ${localStorage?.access_token}`);
        headers.set("atkn_bnd", localStorage?.atkn_bnd);
        headers.set("rtkn_bnd", localStorage?.rtkn_bnd);
        headers.set("channelidobo", "ETPBMS");
      }
      if(localStorage.first_token && localStorage.first_token !=""){
        headers.set("authorization", `Bearer ${localStorage?.first_token}`);
        headers.set("atkn_bnd", localStorage?.atkn_bnd);
        headers.set("rtkn_bnd", localStorage?.rtkn_bnd);
        headers.set("channelidobo", "ETPBMS");
      }
      headers.set("currentRole", localStorage.userrole);
      // if((localStorage.userrole !== "eci"&&localStorage.userrole !== "nodal"&&localStorage.userrole !== "record"&&localStorage.userrole !== "unit") &&localStorage.userrole)
      // {
      //   headers.set("statecd", parseJwt(localStorage.access_token)?.authorizedStates?.[0]);
      // }
      return headers;
    }, 
  }),
    keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    changePassword: builder.mutation({
      query: (data) => ({
        headers: {
          "Content-Type": "application/json",
        },
        url: `/api/v1/etpbms-user-management/change/user/password`,
        method: "POST",
        body: data,
      }),
    }),
    changePassword: builder.mutation({
        query: (data) =>({
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.first_token,
          
          },
          url: 'api/v1/etpbms-user-management/change/password',
          method: 'POST',
          body: data
       })
      }),
   
    uploadFile: builder.mutation({
      query: (data) => ({
        url: "/api/v1/etpbms-user-management/uploadUser",
        method: "POST",
        body: data,
   
        // headers: {
          // 'Authorization': 'Bearer ' + localStorage.access_token,
          // 'Content-Type': 'application/json',
        //  'currentrole' :"ero",
          // 'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
      //  },
      }),
    }),

/******** Usermanagement Get All users  */
    getAllUser: builder.query({
      query: (userLogin) => ({
        url: "/api/v1/etpbms-user-management/getAllUsers",
        method: "GET",
        headers:{
          "statecd":localStorage.access_token && parseJwt(localStorage.access_token)?.authorizedStates?.[0],
          constType: parseJwt(localStorage.access_token)?.constituencyType,
          constNo: parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        }
      }),
    }),


    getUserById: builder.query({
      query: (userId) => ({
        url: `/api/v1/etpbms-user-management/getUser/${userId}`,
        method: "GET",
        headers:{
          "statecd":localStorage.access_token && parseJwt(localStorage.access_token)?.authorizedStates?.[0],
          constType: parseJwt(localStorage.access_token)?.constituencyType,
          constNo: parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        }
      }),
    }),


    MasterDataUserUpdate: builder.mutation({
      headers: {
        "Content-type": "application/json;",
      },
      query: (data) => ({
        url: "/api/v1/etpbms-user-management/updateUserDetails",
        method: "POST",
        body: data,
        headers:{
          "statecd":localStorage.access_token && parseJwt(localStorage.access_token)?.authorizedStates?.[0],
          constType: parseJwt(localStorage.access_token)?.constituencyType,
          constNo: parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        }
      }),
    }),

    getElectionAnnouncedAcs: builder.query({
      query: (userId) => ({
        url: `api/v1/etpbms-user-management/commonData`,
        method: "GET",
        headers:{
          "statecd":localStorage.access_token && parseJwt(localStorage.access_token)?.authorizedStates?.[0],
          "currentrole":localStorage.userrole
        }
      }),
    }),

    getStateLang: builder.query({
      query: (userLogin) => ({
        url: "/api/v1/etpbms-user-management/getStateLang",
        method: "GET",
        headers:{
          "statecd":localStorage.access_token && parseJwt(localStorage.access_token)?.authorizedStates?.[0]
        }
      }),
    }),

    
    UnlockUser: builder.mutation({
      headers: {
        "Content-type": "application/json;",
      },
      query: (data) => ({
        url: "/api/v1/etpbms-user-management/enableUserKeyCloak",
        method: "POST",
        body: data,
      }),
    }),

    updateDistrictDetails: builder.mutation({
      query: (data) => ({
        url: `api/v1/etpbms-user-management/updateDistrictDetails`,
        method: "POST",
        body: data,
        headers: {
            "Content-Type": "application/json",
            "currentrole":localStorage.userrole
        },
      }),
    }),

    updateAcDetails: builder.mutation({
      query: (data) => ({
        url: `api/v1/etpbms-user-management/updateAcDetails`,
        method: "POST",
        body: data,
        headers: {
            "Content-Type": "application/json",
            "currentrole":localStorage.userrole
        },
      }),
    }),

    updatePcName: builder.mutation({
      query: (data) => ({
        url: `api/v1/etpbms-user-management/updatePcName`,
        method: "POST",
        body: data,
        headers: {
            "Content-Type": "application/json",
            "currentrole":localStorage.userrole
        },
      }),
    }),
  }),
});
export const {
  useChangePasswordMutation,
  useUploadFileMutation,
  useGetAllUserQuery,
  useMasterDataUserUpdateMutation,
  useGetUserByIdQuery,
  useGetElectionAnnouncedAcsQuery,
  useGetStateLangQuery,
  useUnlockUserMutation,
  useUpdateDistrictDetailsMutation,
  useUpdateAcDetailsMutation,
  useUpdatePcNameMutation
} = userServiceApi;
